module.exports = __webpack_public_path__ + "img/coaching_2-sm.64e57737.png";